import {useMemo} from 'react';
import {initializeConnector, Web3ReactHooks} from '@web3-react/core';
import {Web3ConnectionType} from '../types';
import {Actions, Connector, Web3ReactStore} from '@web3-react/types';

export interface InitializedConnector<T extends Connector> {
  type: Web3ConnectionType;
  hooks: Web3ReactHooks;
  store: Web3ReactStore;
  connector: T;
}

export const useInitializeConnector = <T extends Connector>(
  type: Web3ConnectionType,
  f: (actions: Actions) => T
): InitializedConnector<T> => {
  return useMemo(() => {
    const [connector, hooks, store] = initializeConnector(f);

    return {
      type,
      hooks,
      store,
      connector,
    };
  }, [type, f]);
};
